<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.Header.name')" prop="name">
            <BjInput
              v-model="queryParams.name"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.Header.code')" prop="code">
            <BjInput
              v-model="queryParams.code"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.Header.status')" prop="enableFlag">
            <el-select v-model="queryParams.enableFlag" :placeholder="$t('chooseText')" clearable>
              <el-option
                v-for="(item, index) in STATUS_ENABLED_TRUE"
                :key="index"
                :label="$t(item.label)"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button
            v-permission:BusinessChannelStorageIndex_Add
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('WarehouseManagement.Header.Add') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <el-tag
                v-else-if="col.prop === 'logicalFlag'"
                :type="scope.row.logicalFlag ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row.logicalFlag)) }}</el-tag
              >
              <span v-else-if="col.prop === 'detailAddress'">{{
                scope.row.provinceName +
                scope.row.cityName +
                scope.row.districtName +
                scope.row.detailAddress
              }}</span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-permission:BusinessChannelStorageIndex_Edit
                type="text"
                class="edit-btn"
                @click="onEdit(props.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-if="props.row.logicalFlag"
                v-permission:BusinessChannelStorageIndex_Status
                type="text"
                @click="onStatus(false, props.row)"
                >{{ $t('disableText') }}</el-button
              >
              <el-button
                v-if="!props.row.logicalFlag"
                v-permission:BusinessChannelStorageIndex_Status
                type="text"
                @click="onStatus(true, props.row)"
                >{{ $t('enableText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { channelApi } from '@/api';
import { STATUS_ENABLED_TRUE } from '@/utils/constants';
import DataForm from './components/DataForm.vue';

export default {
  name: 'BusinessChannelStorage',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_TRUE,
      queryApi: channelApi.getWarehousePage,
      selection: false,
      // 查询参数
      queryParams: {
        name: null,
        code: null,
        enableFlag: null,
      },
      labelsVersion: 11,
      labelList: [
        { label: this.$t('WarehouseManagement.Header.code'), prop: 'code', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('WarehouseManagement.Header.name'), prop: 'name', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('WarehouseManagement.Main.name'), prop: 'contactName', isCheck: true, disabled: false, width: 135 },
        { label: this.$t('WarehouseManagement.Main.phone'), prop: 'contactPhone', isCheck: true, disabled: false, width: 135 },
        { label: this.$t('WarehouseManagement.Main.address'), prop: 'detailAddress', isCheck: true, disabled: false, width: 230 },
        { label: this.$t('WarehouseManagement.Main.warehouse'), prop: 'logicalWarehouseName', isCheck: true, disabled: false, width: 177 },
        { label: this.$t('WarehouseManagement.Header.status'), prop: 'logicalFlag', isCheck: true, disabled: false, width: 177 },
        { label: this.$t('WarehouseManagement.Main.by'), prop: 'createdName', isCheck: true, disabled: false},
        { label: this.$t('WarehouseManagement.Main.time'), prop: 'creationDate', isCheck: true, disabled: false, width: 180 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 135 },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    /** 新增门店 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      channelApi.getWarehouseDetails({ id: row.id }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$refs.DataForm.show(this.$lodash.clone({ ...row, ...res }));
        }
      });
    },

    /** 禁用 */
    onStatus(flag, row) {
      this.$confirm(
        this.$t('WarehouseManagement.Main.ps1'),
        this.$t('toast.hintText'),
        {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        },
      )
        .then(() => {
          this.operationWarehouse({
            id: row.id,
            flag,
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    onDelete(row) {
      const ids = [row.id];
      this.$confirm(this.$t('WarehouseManagement.Main.ps'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('WarehouseManagement.Main.ps'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    /* **********************新建仓库************************** */
    /**  */

    // 禁用API
    operationWarehouse(API_DATA) {
      channelApi.operationWarehouse(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      channelApi.batchDeleteWarehouse(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.dialogForm {
  .el-input {
    width: 240px;
  }
}
</style>
